import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';

import { EffectsBase } from '@ps/core-data-access';
import { SurveyActivityLogActions } from '@ps/survey-data-access';

import { SurveyCreationLaunchActions } from './survey-creation-launch.actions';
import { launchActivityLogEntry } from './utils/activity-log.helper';

/**
 * Split from `SurveyCreationLaunchEffects` because this is a pure
 * trigger→log translation, sharing nothing with the rest of the launch
 * effects (form loading, URLs, billing check) — see `state/core/README.md`
 * on splitting per effect rather than per file.
 *
 * Single generic action (`logSurveyLaunchActivity`) for every survey-launch
 * activity-log trigger — the `trigger` union decides what gets logged. To
 * add a new trigger: add a union member to `SurveyLaunchActivityLogTrigger`
 * and a matching `.with()` branch here; `.exhaustive()` forces it.
 */
@Injectable()
export class SurveyCreationLaunchActivityLogEffects extends EffectsBase {
  private readonly _actions$ = inject(Actions);

  public readonly logSurveyLaunchActivity$ = createEffect(() =>
    this._actions$.pipe(
      ofType(SurveyCreationLaunchActions.logSurveyLaunchActivity),
      map(({ surveyId, trigger }) =>
        SurveyActivityLogActions.logActivity({
          log: {
            eventSource: 'user',
            surveyId,
            ...launchActivityLogEntry(trigger),
          },
        }),
      ),
    ),
  );
}
